const trigger = (eventName, el, data = {}) => {
  let event
  if (typeof window.CustomEvent === 'function') {
    event = new CustomEvent(eventName, { detail: data })
  } else {
    event = document.createEvent('CustomEvent')
    event.initCustomEvent(eventName, true, true, data)
  }
  el.dispatchEvent(event)
  return el
}

function productClickDataLayer(product) {
  trigger('productClick', document, { product: product, list: product.list });
}

function newsletterClickDataLayer(data) {
  trigger('customEvents', document, { data: data });
}

const subscriptionButtons = document.querySelectorAll(`[data-subscribe-button]`);
if (subscriptionButtons) {
  subscriptionButtons.forEach( subscriptionButton => {
    subscriptionButton.addEventListener("click", function(evt) {
      const data = {
        "event": "ce_subscription_placed",
        "eventCategory": "subscription",
        "eventAction": "click",
        "eventLabel": "purchase",
        "eventValue": "order total"
      };
      trigger('customEvents', document, { data: data });
    })
  })
}

const consultationLinks = document.querySelectorAll(`.js-consultation`);

if (consultationLinks) {
  consultationLinks.forEach( consultationLink => {
    consultationLink.addEventListener("click", function(evt) {
      const data = {
        "event": "ce_quiz_click",
        "eventCategory": "quiz",
        "eventAction": "click",
        "eventLabel": "*header",
        "eventValue": "footer"
      };
      trigger('customEvents', document, { data: data });
    })
  })
}

const relocateDetails = () => {
  const startedClick = document.querySelector('.oct-quiz-btn.oct-quiz-btn--primary');
  if (startedClick) {
    startedClick.addEventListener("click", function(evt) {
      const data = {
        "event": "ce_quiz_started",
        "eventCategory": "start",
        "eventAction": "view",
        "eventLabel": "quiz_name",
        "eventValue": ""
      };
      trigger('customEvents', document, { data: data });
    })
  }
}

window.addEventListener('load', (event) => {
  relocateDetails()
});

const addToCartQuiz = () => {
  $.ajax({
    type: "GET",
    url: "/cart.json",
    datatype: "json",
    async: false,
    success: function(cart) {
      const data = {
        "event": "ce_quiz_add_to_cart",
        "eventCategory": "addToCart",
        "eventAction": "click",
        "eventLabel": cart.items[0].product_title,
        "eventValue": cart.items[0].final_price
      };
      trigger('customEvents', document, { data: data });
    }
  });
}

document.addEventListener('octane.quiz.completed', function (e) {
  const data = {
    "event": "ce_quiz_completed",
    "eventCategory": "results",
    "eventAction": "view",
    "eventLabel": "quiz_name",
    "eventValue": ""
  };
  trigger('customEvents', document, { data: data });
}, false);

document.addEventListener('octane.quiz.addToCart', function (e) {
  addToCartQuiz()
}, false);